<div class="xl-invoice"
	[ngClass]="[rowCountIsEven?'invoice-commission-even': 'invoice-commission-odd', isDetailMode?'invoice-detail-mode':'']">
	<!--Pay Amount-->
	<div class="table-row">
		<span class="label">
			<ng-container *ngIf="payAmountTitle !== undefined">
				{{payAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="payAmountTitle === undefined">
				{{'REQUEST.COMMISSION.PAY_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span class="value">
			<div class="money-amount">
				{{ commission.requestedAmount | tcCurrency: commission.requestedPrecision }}</div>
			<div class="money-currency-code">
				{{commission.requestedCurrencyCode}}
			</div>
		</span>
	</div>

	<!--Exchange Rate-->
	<div class="table-row">
		<span class="label">
			{{'REQUEST.COMMISSION.EXCHANGE_RATE' | translate}}
		</span>

		<span class="value">
			<div class="money-amount">
				{{ commission.exchangeRate | tcCurrency: 10 }}</div>
			<div class="money-currency-code">
				<ng-container *ngIf="commission.exchangeRate !== 1">
					{{commission.exchangeCurrencyCode}}
				</ng-container>
			</div>
		</span>
	</div>

	<!--CONVERSION AMOUNT-->
	<div class="table-row">
		<span class="label">
			{{'REQUEST.COMMISSION.CONVERTED_AMOUNT' | translate}}
		</span>
		<span class="value">
			<div class="money-amount">
				{{commission.convertedAmount | tcCurrency: (commission.convertedPercision ??
				commission.payOrGetPrecision) }}</div>
			<div class="money-currency-code">
				{{commission.convertedCurrencyCode ? commission.convertedCurrencyCode : commission.payOrGetCurrencyCode
				}}
			</div>
		</span>
	</div>

	<ng-container *ngIf="commission.commissionType !== commissionType.NONE">
		<!--Commission-->
		<div class="table-row">
			<span class="label">
				<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
					{{'REQUEST.COMMISSION.INITIAL_COST' | translate}}
				</ng-container>

				<ng-container *ngIf="commission.commissionType === commissionType.BONUS">
					{{'REQUEST.COMMISSION.BONUS_FIXED_AMOUNT' | translate}}
				</ng-container>
			</span>

			<span class="value">
				<div class="money-amount">
					{{commission.commissionInitialFee | tcCurrency: (commission.commissionPercision ?? commission.payOrGetPrecision)}}
				</div>
				<div class="money-currency-code" *ngIf="commission.commissionInitialFee > 0">
					{{ commission.commissionCurrencyCode ? commission.commissionCurrencyCode :
					commission.payOrGetCurrencyCode }}
				</div>
			</span>
		</div>

		<div class="table-row">
			<span class="label invoice-bonus">
				<span>
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.COMMISSION' | translate}}
					</ng-container>

					<ng-container *ngIf="commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.BONUS' | translate}}
					</ng-container>
					<ng-container *ngIf="commission.commissionPercent != 0">{{commission.commissionPercent}}%
					</ng-container>
				</span>
				<span class="data"
					*ngIf="(commission.minCommission > 0 || commission.maxCommission > 0) &&
                 commission.commissionAmount > 0 && (commission.commissionCalcType && commission.commissionCalcType !== commissionCalcType.CALCULATED)">

					<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MINIMUM">
						<!--title-->
						<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
							{{'REQUEST.COMMISSION.MINIMUM_COMMISION' | translate}}</ng-container>
						<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
							{{'REQUEST.COMMISSION.MINIMUM_BONUS' | translate}}</ng-container>
						<!--amount-->
						<span class="amount">
							<span class="number">
								{{commission.minCommission | tcCurrency: (commission.commissionPercision ?? commission.payOrGetPrecision) }}
							</span>
							<span class="currency">
								{{commission.commissionCurrencyCode ? commission.commissionCurrencyCode :
								commission.payOrGetCurrencyCode}}
							</span>
						</span>
					</span>

					<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MAXIMUM">
						<!--title-->
						<ng-container *ngIf=" commission.commissionType === commissionType.COMMISSION">
							{{'REQUEST.COMMISSION.MAXIMUM_COMMISION' | translate}}</ng-container>
						<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
							{{'REQUEST.COMMISSION.MAXIMUM_BONUS' | translate}}</ng-container>

						<span class="amount">
							<span class="number">
								{{commission.maxCommission | tcCurrency: (commission.commissionPercision ?? commission.payOrGetPrecision)}}
							</span>
							<span class="currency">
								{{commission.commissionCurrencyCode ? commission.commissionCurrencyCode :
								commission.payOrGetCurrencyCode}}
							</span>
						</span>
					</span>
				</span>
			</span>

			<span class="value">
				<div class="money-amount">
					{{ commission.commissionAmount | tcCurrency: (commission.commissionPercision ?? commission.payOrGetPrecision) }}</div>
				<div class="money-currency-code">
					<ng-container *ngIf="commission.commissionAmount > 0">
						{{ commission.commissionCurrencyCode ? commission.commissionCurrencyCode
						:commission.payOrGetCurrencyCode }}
					</ng-container>
				</div>
			</span>
		</div>

	</ng-container>

	<!--Point-->
	<div class="table-row" *ngIf="commission.point !== null && commission.point > 0">
		<span class="label">
			{{'REQUEST.COMMISSION.POINT' | translate}}
		</span>

		<span class="value">
			{{commission.point | tcCurrency: pointPrecision}}
		</span>
	</div>

	<!--Charge Amount-->
	<div class="table-row">
		<span class="label">
			<ng-container *ngIf="getAmountTitle !== undefined">
				{{getAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="getAmountTitle === undefined">
				{{'REQUEST.COMMISSION.GET_AMOUNT' | translate}}
			</ng-container>
		</span>
		<span class="green value">
			<div class="money-amount">
				{{commission.payOrGetAmount | tcCurrency: commission.payOrGetPrecision}}</div>
			<div class="money-currency-code">
				{{commission.payOrGetCurrencyCode}}
			</div>

		</span>
	</div>
</div>